import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const SHIFT_FOR_CAPITALS_ACTIVITY_FRAGMENT = gql `
  fragment ShiftForCapitalsActivityFragment on ShiftForCapitalsActivity {
    rounds {
      answer
      answerImage {
        image {
          ...AssetFragment
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default SHIFT_FOR_CAPITALS_ACTIVITY_FRAGMENT;
